interface IProps {
  rejectDescription: string;
}

const RejectLoanRequestDesc = ({rejectDescription}: IProps) => {
  return (
    <div className="flex flex-col items-center justify-center gap-3 mt-8">
      <div className="flex items-center justify-center p-2 bg-red-600 rounded-full aspect-square">
        <i className="text-3xl font-semibold text-white icon-nameClose-remove" />
      </div>
      <span className="text-xl font-bold">عدم تایید درخواست</span>
      <span className="my-4 text-gray-700 text-md">
        درخواست شما به دلیل یکی از موارد زیر رد شده است. بعد از حل مشکل دوباره
        تلاش کنید.
      </span>
      <div className="flex items-start justify-start w-full px-2 ">
        <div
          className="w-full text-right text-md richText max-h-[40vh] overflow-y-auto pb-10 "
          dangerouslySetInnerHTML={{__html: rejectDescription}}
        />
      </div>
    </div>
  );
};
export default RejectLoanRequestDesc;
